import getAPI from './getAPI.js'

export default async function getAdminFeedback() {
    const data = await getAPI('admin/feedback');
    return data;
}
